import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { Activity } from '@totem/components/ticketing/ticketing';
import Working from '@totem/components/ui_components/pageExceptions/working/working';
import { isNotNull } from '@totem/utilities/common';
import { UNAUTHENTICATED_TICKET_ENDPOINT } from '@totem/utilities/endpoints';

const AutoActions = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const action = searchParams.get('action');
  const msg = searchParams.get('msg');

  const [isSending, setIsSending] = useState(false);

  const sendActivity = useCallback(
    async (request: Activity) => {
      if (isSending) {
        return;
      }

      fetch(`${UNAUTHENTICATED_TICKET_ENDPOINT}/activities`, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${id}`,
        }),
        body: JSON.stringify(request),
      })
        .then((res) => res.json())
        .then(() => {
          navigate(`/ticket/${id}`, { replace: true });
        })
        .then(() => {
          setIsSending(false);
        });

      setIsSending(true);
    },
    [isSending],
  );

  useEffect(() => {
    if (!action) return;

    switch (action) {
      case 'resolve':
        {
          const resolveRequest: Activity = {
            id: '',
            type: {
              id: '00000055f3329dc06f000001',
              code: 'RESOLVE',
              display: 'Resolve Ticket',
            },
            notes: {
              isRichText: true,
              plainText:
                isNotNull(msg) && msg !== '' ? msg : 'Resolved from Link',
              htmlText:
                isNotNull(msg) && msg !== '' ? msg : 'Resolved from Link',
            },
            attributes: [],
            createdByType: 'User',
            createdByName: '',
            createdById: '',
            createdAt: new Date().toISOString(),
            isPrivate: false,
            keys: [],
          };

          sendActivity(resolveRequest);
        }
        break;
      default:
        navigate(`/ticket/${id}`, { replace: true });
        break;
    }
  }, []);

  return (
    <Working
      subTitle={'Processing ticket update'}
      continueLink={`/ticket/${id}`}
      continueText={'Continue to Ticket'}
    />
  );
};

export default AutoActions;
